export const BIV1 = [
  "propertiesCompletedWithinLast36Months",
  "foreignNational",
  "ImmigrationStatus",
  "originalCreditScore",
  "InState",
];

export const quickLoanBIV1 = [
  "borrowerType",
  "citizenshipStatus",
  "creditScoreActual",
  "borrowingEntityName",
  "borrowerEmail",
  "borrowerName",
  "guarantorName",
  "guarantorEmail",
];

export const detailedLoanBIV1 = [
  "borrowerType",
  "creditScoreActual",
  "citizenshipStatus",
  "FirstTimeHomeBuyer"
];

export const detailedLoanBIV2 = [
  "borrowerType",
  "creditScoreActual",
  "citizenshipStatus",
  "borrowingEntityName",
  "borrowerName",
  "borrowerEmail",
  "guarantorName",
  "guarantorEmail",
  "FirstTimeHomeBuyer",
];